import { Alert, Button, Group, Modal, Stack, Text } from "@mantine/core";
import { describeRpcError } from "@how/app-kit";
import { useUnfulfilOrder } from "./store-queries";

/**
 * Undoing a hand-over (#280, ADR 0047 step 3): asks about the order by its number before a picked-up order goes back
 * to paid. Used by Store → Orders and the event roster. No reason is asked for (owner 2026-10-01): the audit already
 * says who undid it and when. The database refuses what may not be undone, in its own words.
 */
export function UndoPickupDialog({
  title,
  orderId,
  orderNumber,
  onClose,
  onUndone,
}: {
  readonly title: string;
  readonly orderId: string;
  readonly orderNumber: number;
  readonly onClose: () => void;
  readonly onUndone: () => void;
}) {
  const undo = useUnfulfilOrder();
  return (
    <Modal opened onClose={onClose} title={title}>
      <Stack gap="sm">
        <Text size="sm">Mark order {orderNumber} as not picked up?</Text>
        <Text size="sm" c="dimmed">
          It goes back to paid, ready to hand over again. Nothing is refunded and nothing goes back
          into stock.
        </Text>
        {undo.isError ? (
          <Alert color="red" variant="light">
            {describeRpcError(undo.error).message}
          </Alert>
        ) : null}
        <Group justify="flex-end">
          <Button variant="subtle" onClick={onClose}>
            Keep it picked up
          </Button>
          <Button
            loading={undo.isPending}
            onClick={() => {
              undo.mutate({ orderId }, { onSuccess: onUndone });
            }}
          >
            Mark not picked up
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
